function autoLoader() {
  const currentUrl = window.location.pathname;
  if (!currentUrl.includes("collections") && !currentUrl.includes("search")) return;

  const productsContainer = document.getElementById("product-grid");
  const loadMoreBtn = document.getElementById("load-more-cstm-btn"); // Changed to ID selector
  if (!productsContainer || !loadMoreBtn) return;

  let isLoading = false;
  let noMoreProducts = false;

  // --- Load products function ---
  async function loadMoreProducts() {
    const nextUrl = productsContainer.getAttribute("data-next-url");
    if (!nextUrl || isLoading || noMoreProducts) return;

    isLoading = true;
    loadMoreBtn.style.display = "none";
    document.body.classList.add("loading");

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");
      const newProductsContainer = doc.querySelector("#product-grid");
      const newProducts = newProductsContainer.querySelectorAll(".grid__item");
      const newNextUrl = newProductsContainer.getAttribute("data-next-url");

      if (newProducts.length === 0) {
        noMoreProducts = true;
        loadMoreBtn.textContent = "No more products";
        loadMoreBtn.style.display = "block"; // Keep button visible but with "No more products" text
        loadMoreBtn.classList.add("ds-no-more-products-left");
        return;
      }

      newProducts.forEach((product) => productsContainer.appendChild(product));

      if (newNextUrl) {
        productsContainer.setAttribute("data-next-url", newNextUrl);
        loadMoreBtn.style.display = "block";
        loadMoreBtn.textContent = "Show More"; // Match the original button text
      } else {
        noMoreProducts = true;
        loadMoreBtn.textContent = "No more products";
        loadMoreBtn.style.display = "block"; // Keep button visible with "No more products" text
        loadMoreBtn.classList.add("ds-no-more-products-left");
      }

      // Reinitialize functions for new products
      if (typeof productGridSlider === 'function') productGridSlider();
      if (typeof manageAddToBag === 'function') manageAddToBag();

    } catch (err) {
      console.error("Error loading products:", err);
      loadMoreBtn.style.display = "block";
    } finally {
      isLoading = false;
      document.body.classList.remove("loading");
    }
  }

  // --- Reset state function ---
  function resetAutoLoader() {
    noMoreProducts = false;
    isLoading = false;
    loadMoreBtn.style.display = "block";
    loadMoreBtn.textContent = "Show More"; // Reset to original "Show More" text
    loadMoreBtn.classList.remove("ds-no-more-products-left");
  }

  // --- Attach scroll and click listeners ---
  // Remove existing listeners first to prevent duplicates
  loadMoreBtn.replaceWith(loadMoreBtn.cloneNode(true));
  const newLoadMoreBtn = document.getElementById("load-more-cstm-btn"); // Changed to ID selector
  
  newLoadMoreBtn.addEventListener("click", loadMoreProducts);

  // Create a single scroll handler
  function handleScroll() {
    if (noMoreProducts || isLoading) return;

    const scrollTrigger = window.innerHeight + window.scrollY;
    const nearBottom = productsContainer.offsetTop + productsContainer.offsetHeight - 500;

    if (scrollTrigger >= nearBottom) loadMoreProducts();
  }

  // Remove previous scroll listener if exists and add new one
  window.removeEventListener("scroll", window.autoLoaderScrollHandler);
  window.autoLoaderScrollHandler = handleScroll;
  window.addEventListener("scroll", window.autoLoaderScrollHandler);

  // --- MutationObserver to detect filter/sort updates ---
  // Disconnect previous observer if exists
  if (window.autoLoaderObserver) {
    window.autoLoaderObserver.disconnect();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-next-url') {
        // data-next-url attribute changed - this happens on filter/sort
        resetAutoLoader();
        break;
      } else if (mutation.type === "childList" && mutation.removedNodes.length > 0) {
        // Products were removed (likely due to filter/sort)
        resetAutoLoader();
        break;
      }
    }
  });

  observer.observe(productsContainer, { 
    childList: true, 
    attributes: true,
    attributeFilter: ['data-next-url'],
    subtree: false 
  });

  // Store observer reference globally to allow cleanup
  window.autoLoaderObserver = observer;
}

// Reinitialize autoLoader when DOM changes (for dynamic page updates)
function reinitializeAutoLoader() {
  const productsContainer = document.getElementById("product-grid");
  const loadMoreBtn = document.getElementById("load-more-cstm-btn"); // Changed to ID selector
  
  if (productsContainer && loadMoreBtn && !productsContainer.hasAttribute('data-auto-loader-initialized')) {
    productsContainer.setAttribute('data-auto-loader-initialized', 'true');
    autoLoader();
  }
}

// Initial load
document.addEventListener("DOMContentLoaded", autoLoader);

// Reinitialize when Shopify's AJAX page updates occur
document.addEventListener("shopify:section:load", reinitializeAutoLoader);
document.addEventListener("shopify:section:unload", reinitializeAutoLoader);

// Fallback: observe body for dynamic content changes
if (typeof MutationObserver !== 'undefined') {
  const bodyObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && (node.id === 'product-grid' || node.querySelector('#product-grid'))) {
            setTimeout(reinitializeAutoLoader, 100);
          }
        });
      }
    }
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });
}



//  function autoLoader(){const current_url = window.location.pathname;
  
//     if (current_url.includes("collections") || current_url.includes("search")) {
//       var products_on_page = document.getElementById("product-grid");
//       console.log(products_on_page)
//       var next_url = products_on_page.getAttribute("data-next-url");
//       var loadmore_btn = document.querySelector(".load-more-cstm-btn");
//       console.log(next_url)
//       function loadMoreProducts() {
//         fetch(next_url)
//           .then((response) => {
//             loadmore_btn.style.display = "none";
//             return response.text();
//           })
//           .then((data) => {
//             var parser = new DOMParser();
//             var doc = parser.parseFromString(data, "text/html");
//             var return_html = doc.body;
//             var main_html = return_html.querySelector("#product-grid");
//             var main_html_child = main_html.querySelectorAll(".grid__item");
//             var new_url = main_html.getAttribute("data-next-url");
//             if (new_url) {
//               document.querySelector("#product-grid").setAttribute("data-next-url",main_html.getAttribute('data-next-url'))
//               loadmore_btn.style.display = "none";
//               document.documentElement.classList.remove("loading");
//             }
//             else{
//               document.documentElement.classList.remove("loading");
//             }
//             next_url = new_url;
//             let mainProductWrapper = document.querySelector(".product-grid");
//             setTimeout(() => {
//               main_html_child.forEach(function (value, index) {             
//                 document.querySelector(".product-grid").append(value);
//               });
//               productGridSlider();
//               manageAddToBag();
              
//               if (new_url) {
//                 loadmore_btn.style.display = "block";
//                 document.querySelector('body').classList.remove("loading");  
  
//               } else {
//                 document.querySelector('body').classList.remove("loading");
//                 loadmore_btn.style.display = "block";
//                 loadmore_btn.classList.add("ds-no-more-products-left");
//                 loadmore_btn.classList.add("ds-no-more-products-left");
//                 loadmore_btn.textContent="No more products";
//               }
//             }, 600);
//           })
//           .catch((err) => {
//             console.log(err);
//           });
//       }
    
//       if (document.querySelectorAll("#load-more-cstm-btn").length > 0) {
//         if (
//           document
//             .querySelector("#load-more-cstm-btn")
//             .classList.contains("ds-no-more-products-left")
//         ) {
//         } else {
//           document
//             .querySelector("#load-more-cstm-btn")
//             .addEventListener("click", () => {
//               setTimeout(loadMoreProducts,500)
//             });
//         }
//       }
//       var btnClick = new Event("click");
//       document.addEventListener("scroll", function () {
//         var collectionTplElm = document.querySelector(".collection_top-wrapper");
//         var collectionTop = window.innerHeight;
//         var collectionHeight = collectionTplElm.clientHeight;
//         var posTop = collectionTop + collectionHeight - window.innerHeight;
    
//         if (
//           window.pageYOffset > posTop - 1000 &&
//           window.pageYOffset < posTop + 1000
//         ) {
//           if (loadmore_btn) {
//             if (loadmore_btn.classList.contains("btn-disabled")) {
//             } else {
//               loadmore_btn.dispatchEvent(btnClick);
//               loadmore_btn.classList.add("btn-disabled");
//               setTimeout(function () {
//                 if (loadmore_btn) {
//                   if (loadmore_btn.classList.contains("ds-no-more-products-left")) {
//                   } else {
//                     loadmore_btn.classList.remove("btn-disabled");
//                   }
//                 }
//               }, 3000);
//             }
//           }
//         }
//       });
//     }
//     }autoLoader();
  